import axios from 'axios'
import { beforeRequestError, beforeRequestSuccess, onError, onSuccess } from '../interceptors'
import env from '../../public/env.json'
import getConfig from '../../utils/config'
import { API_DEFAULT_TIMEOUT_MS } from '@/utils/constants'
const config = getConfig(env.environment)

const webClient = axios.create({
  baseURL: config.webapiRebtelFastlyUrl,
  timeout: API_DEFAULT_TIMEOUT_MS,
  headers: {
    'Content-Type': 'application/json; charset=UTF-8'
  }
})

webClient.interceptors.request.use(beforeRequestSuccess, beforeRequestError)
webClient.interceptors.response.use(onSuccess, onError('Web API'))

export const client = webClient
